if (navigator.userAgent.match(/iPhone/i)) {
  document.body.classList.add("is-iphone")
}
